import { createServerFn } from "@tanstack/react-start";

/**
 * Returns the public Sentry DSN plus release/environment metadata used to
 * tag every captured event. DSNs are designed to be public per Sentry's
 * threat model; release + env are also non-sensitive.
 *
 * Sources (all optional — fall back to `null` so the client can degrade):
 *   - dsn         → SENTRY_DSN
 *   - release     → SENTRY_RELEASE ?? APP_VERSION+COMMIT_SHA ?? COMMIT_SHA
 *   - version     → APP_VERSION ?? npm_package_version
 *   - commit      → COMMIT_SHA ?? CF_PAGES_COMMIT_SHA ?? VERCEL_GIT_COMMIT_SHA
 *   - environment → SENTRY_ENVIRONMENT ?? ENVIRONMENT ?? NODE_ENV
 */
export const getSentryDsn = createServerFn({ method: "GET" }).handler(async () => {
  const env = process.env;
  const commit =
    env.COMMIT_SHA ??
    env.CF_PAGES_COMMIT_SHA ??
    env.VERCEL_GIT_COMMIT_SHA ??
    env.SOURCE_VERSION ??
    null;
  const version = env.APP_VERSION ?? env.npm_package_version ?? null;
  const release =
    env.SENTRY_RELEASE ??
    (version && commit ? `${version}+${commit.slice(0, 7)}` : commit) ??
    null;
  const environment =
    env.SENTRY_ENVIRONMENT ?? env.ENVIRONMENT ?? env.NODE_ENV ?? null;

  return {
    dsn: env.SENTRY_DSN ?? null,
    release,
    version,
    commit,
    commitShort: commit ? commit.slice(0, 7) : null,
    environment,
  };
});
